import { Collapse, IconButton } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import React, { Children, useState } from "react";

export default function CollapseGroup({
  mainItemAction,
  mainItemIcon,
  header,
  defaultOpen,
  children,
  collapseStyle,
}) {
  const [open, setOpen] = useState(defaultOpen || false);
  const _collapseStyle = collapseStyle || { background: "#e6e6e6" };
  return (
    <>
      <ListItem
        button={!children}
        onClick={!children && mainItemAction ? mainItemAction : null}
        style={open ? { boxShadow: "1px 1px 2px" } : null}
      >
        {mainItemIcon ? (
          <ListItemIcon
            onClick={mainItemAction ? mainItemAction : null}
            style={{
              cursor: mainItemAction ? "pointer" : "",
            }}
          >
            {mainItemIcon}
          </ListItemIcon>
        ) : null}
        <ListItemText
          primary={header}
          onClick={mainItemAction ? mainItemAction : null}
          style={{
            cursor: mainItemAction ? "pointer" : "",
          }}
          primaryTypographyProps={{
            style: { fontSize: header.length > 15 ? 13 : "" },
          }}
        />
        {children ? (
          <IconButton
            onClick={(e) => {
              setOpen(!open);
            }}
            style={{ position: "absolute", right: 0, zIndex: 9999 }}
          >
            {open ? <ExpandLess></ExpandLess> : <ExpandMore></ExpandMore>}
          </IconButton>
        ) : null}
      </ListItem>
      <Collapse in={open} style={_collapseStyle}>
        {children && Children.map(children, (Child) => <>{Child}</>)}
      </Collapse>
    </>
  );
}
